import React from 'react';
import {
  BanknotesIcon,
  ChartBarSquareIcon,
  CursorArrowRaysIcon,
} from '@heroicons/react/24/outline';
import { Tooltip } from 'react-tooltip';
import { StatCard } from '../../../components/ui';
import { formatCurrency } from '../../../utils/baseUtils';

const KpiGrid = ({ orderInformations, clickCountLoading }) => {
  const { netPayout, orderCount, clickCount } = orderInformations;

  const cards = [
    {
      icon: BanknotesIcon,
      label: 'Net Sales',
      value: formatCurrency(netPayout),
      tooltip:
        'Estimated amount to be paid to the restaurant after refunds, card processing fees, platform fees, etc.',
    },
    {
      icon: ChartBarSquareIcon,
      label: 'Order Volume',
      value: Number(orderCount).toLocaleString('en-US'),
      tooltip: 'Number of completed orders.',
    },
    {
      icon: CursorArrowRaysIcon,
      label: 'Kiosk Interactions',
      value: Number(clickCount || 0).toLocaleString('en-US'),
      loading: clickCountLoading,
      tooltip:
        'Total kiosk sessions, including sessions that did not result in a completed order.',
    },
  ];

  return (
    <>
      <Tooltip
        id="dashboard-kpi-tooltip"
        place="top"
        positionStrategy="fixed"
        opacity={1}
        style={{ zIndex: 9999 }}
        className="!max-w-[18rem] !rounded-lg !border !border-slate-200 !bg-white !px-3 !py-2.5 !text-xs !font-medium !leading-snug !text-slate-700 !shadow-[0_10px_25px_-5px_rgba(15,23,42,0.12),0_4px_10px_-3px_rgba(15,23,42,0.08)] dark:!border-slate-700 dark:!bg-slate-900 dark:!text-slate-200"
      />
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
        {cards.map((card, index) => (
          <StatCard
            key={card.label}
            icon={card.icon}
            label={card.label}
            uppercaseLabel={false}
            value={card.value}
            loading={card.loading}
            tooltip={card.tooltip}
            tooltipId="dashboard-kpi-tooltip"
            valueClassName="text-blue-600 dark:text-sky-400"
            style={{ animationDelay: `${index * 70}ms` }}
          />
        ))}
      </div>
    </>
  );
};

export default KpiGrid;
